"use client";

import { useRef } from "react";
import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";
import { Link } from "@/components/link/link.component";
import { Loader } from "@/components/loader/loader.component";

import { ProductLineItemModel } from "@/lib/basket/productLineItem.model";

import { GetProductQueryResult } from "@/sanity.types";

import { ProductReplaceKitModal } from "../productReplaceKitModel/productReplaceKitModal.component";

export const ProductActionsKit = ({
  product,
  kits,
}: ProductActionsKitProps) => {
  const { pending } = useFormStatus();

  const confirmationModal = useRef<HTMLDialogElement>(null);
  const submitAction = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const differentKit = kits?.find((kit) => kit.productId !== product?.id);
    // Check if the basket contains a different kit
    if (differentKit) {
      confirmationModal?.current?.showModal();
      return;
    }
    // Get product form
    const productForm = document.getElementById(
      "product-form",
    ) as HTMLFormElement;
    // Submit product form
    productForm?.requestSubmit();
  };
  if (!product?.id || product.type !== "kit") return null;
  return (
    <section data-testid="product-actions-kit" className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 md:flex-row">
        <input
          id="kit-id"
          type="hidden"
          name="kitId"
          defaultValue={product.id}
        />
        <Button
          data-testid="product-actions-kit-add-to-cart"
          secondary
          className="flex-1 cursor-pointer"
          type="button"
          onClick={submitAction}
          disabled={pending}>
          ADD TO CART <Loader loading={pending} size="sm" />
        </Button>
        <Link
          href="#add-to-your-system"
          data-testid="product-actions-kit-customize"
          secondary
          border
          type="button"
          className="flex-1 cursor-pointer">
          START CUSTOMIZING
        </Link>
      </div>
      <ProductReplaceKitModal ref={confirmationModal} />
    </section>
  );
};

export type ProductActionsKitProps = {
  product: GetProductQueryResult;
  kits: ProductLineItemModel[];
};
